import { useState } from 'react';
import { useProspects } from '../../../../../../hooks/fetchers/useProspects/useProspects';
import Loading from '../../../../../commons/Loading/Loading';
import Empty from '../../../../../commons/Empty/Empty';
import Button from '../../../../../designSystem/Button/Button';
import { ButtonColor, ButtonSize } from '../../../../../designSystem/Button/Button.types';
import { useNavigate } from 'react-router-dom';
import { UseProspectsFilters } from '../../../../../../hooks/fetchers/useProspects/useProspects.types';

export default () => {
  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(11);

  const navigate = useNavigate();

  const { data: prospects, isLoading: isProspectsLoading } = useProspects({
    page: currentPage,
    perPage: itemsPerPage,
    filter: UseProspectsFilters.Relancer
  });

  return (
    <>
      {(prospects && prospects?.results.length > 0) ? (
        <table className="dashboard__table dashboard-commerciaux__table">
          <thead>
            <tr>
              <th>Entreprise</th>
              <th>Adresse email</th>
              <th>N° de téléphone</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {isProspectsLoading ? (
              <Loading />
            ) : (
              prospects?.results.map(({ name_company, email, phone, status }, index) => {
                if (index < 10) {
                  return (
                    <tr key={index}>
                      <td>{name_company}</td>
                      <td>{email}</td>
                      <td>{phone}</td>
                      <td>{status}</td>
                    </tr>
                  )
                } else {
                  return (
                    <Button
                      key={index}
                      className="dashboard__table-button--large"
                      size={ButtonSize.Large}
                      color={ButtonColor.Primary}
                      style={{
                        marginTop: 'var(--spacing-sToM)'
                      }}
                      onClick={() => navigate('/dashboard/prospection#relancer')}>
                      Voir tout
                    </Button>
                  )
                }
              })
            )}
          </tbody>
        </table>
      ) : <Empty>Vous n'avez aucun prospect à relancer</Empty>}
    </>
  );
};
